import React from 'react'

export const DarkMode = ({switchTheme,clickedClass,theme,lightTheme}) => {
  

  
  return (
      <button
      id="darkMode"
          onClick={e => { switchTheme(e) }}
      
    >
      {theme ===lightTheme ?
       
              <img src='./images/svg/spider-day.svg' alt='Spider Day Theme At Website Drona'/>
        :
              <img src='./images/svg/spider-night.svg' className='night_spider' width={90} alt='Spider Day Theme At Website Drona' />
        
      }
    </button>
  )
}
